import { type Firestore, doc, getDoc } from 'firebase/firestore';

import { fundPolicySchema, type FundPolicy } from '../../core/fundPolicy/schema';
import type { FundPolicyPort } from '../../features/auth/application/ports/fundPolicyPort';

/**
 * Firestore implementation of `FundPolicyPort` (blueprint §11.1).
 *
 * Validated against the canonical schema at the boundary (§6.3). A policy is
 * edited by hand more often than most documents, and a malformed one should
 * surface here rather than as a declaration form with no questions on it.
 */
export function createFirebaseFundPolicyAdapter(firestore: Firestore): FundPolicyPort {
  return {
    async getCurrentPolicy(): Promise<FundPolicy> {
      const snapshot = await getDoc(doc(firestore, 'fundPolicy', 'current'));

      if (!snapshot.exists()) {
        throw new Error('لم تُضبط سياسة الصندوق بعد. راجع الموارد البشرية.');
      }

      const parsed = fundPolicySchema.safeParse(snapshot.data());
      if (!parsed.success) {
        // Deliberately not partial: a half-valid policy would silently change
        // who is eligible, which is worse than refusing to load.
        throw new Error('سياسة الصندوق غير صالحة. راجع الموارد البشرية.');
      }

      return parsed.data;
    },
  };
}
